import axios from 'axios';
import { BASE_API_URL } from '../config/apiConfig';

// 1. Create Instance
const axiosInstance = axios.create({
    baseURL: BASE_API_URL,
});

// 2. Request Interceptor (Token attach karne ke liye)
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');
        if (token) {
            // Har request mein header automatically add ho jayega
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 3. Response Interceptor (Errors handle karne ke liye)
// 3. Response Interceptor (Errors handle karne ke liye)
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        // 🌟 CHECK: Kya is request mein skipAuthCheck bheja gaya tha?
        if (error.config && error.config.skipAuthCheck) {
            return Promise.reject(error); // Kuch mat karo, chupchaap error return kar do
        }

        if (error.response && error.response.status === 401) {
            console.error("Unauthorized! Logging out...");
            localStorage.removeItem('authToken');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;